module.exports = __webpack_public_path__ + "static/multimedia-7987a03a4224127c5a0fe7a7b9d839a5.png";